import axios from '@/libs/api.request'

export const getCustomerList = ({ kw, page, perPage }) => {
  const data = {
    kw,
    page,
    perPage
  }
  return axios.request({
    url: 'customer/list',
    data,
    method: 'post'
  })
}

export const getCustomer = (id) => {
  return axios.request({
    url: 'customer/' + id,
    method: 'get'
  })
}

export const addCustomer = (title, abbr, address, contacter, phone, note) => {
  const data = {
    title,
    abbr,
    address,
    contacter,
    phone,
    note
  }
  return axios.request({
    url: 'customer/add',
    data,
    method: 'post'
  })
}

export const deleteCustomer = (id) => {
  return axios.request({
    url: 'customer/' + id,
    method: 'delete'
  })
}

export const modifyCustomer = (id, title, abbr, address, contacter, phone, note) => {
  const data = {
    title,
    abbr,
    address,
    contacter,
    phone,
    note
  }
  return axios.request({
    url: 'customer/' + id,
    data,
    method: 'post'
  })
}
